import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CoreModule } from '../../core/core.module';
import { AppModuleGlobalShared } from '../../../app.module.global';
import { PaisFrListComponent } from './paisesfr/paisfr-list.component';
import { PaisFrEditComponent } from './paisesfr/paisfr-edit.component';
import { PaisFrService } from './paisesfr/paisfr.service';
import { GrupoPaisFrListComponent } from './grupospaisesfr/grupopaisfr-list.component';
import { GrupoPaisFrEditComponent } from './grupospaisesfr/grupopaisfr-edit.component';
import { GrupoPaisFrService } from './grupospaisesfr/grupopaisfr.service';
import { GrupoTaricFrListComponent } from './grupostaricfr/grupotaricfr-list.component';
import { GrupoTaricFrEditComponent } from './grupostaricfr/grupotaricfr-edit.component';
import { GrupoTaricFrService } from './grupostaricfr/grupotaricfr.service';
import { GrupoTaricFrSanidadExteriorListComponent } from './grupostaricfrsanidadexterior/grupotaricfrsanidadexterior-list.component';
import { GrupoTaricFrSanidadExteriorEditComponent } from './grupostaricfrsanidadexterior/grupotaricfrsanidadexterior-edit.component';
import { GrupoTaricFrSanidadExteriorService } from './grupostaricfrsanidadexterior/grupotaricfrsanidadexterior.service';
import { GrupoEspecieFrListComponent } from './gruposespeciesfr/grupoespeciefr-list.component';
import { GrupoEspecieFrEditComponent } from './gruposespeciesfr/grupoespeciefr-edit.component';
import { GrupoEspecieFrService } from './gruposespeciesfr/grupoespeciefr.service';
import { GrupoTaricFrExListComponent } from './grupostaricfrex/grupotaricfrex-list.component';
import { GrupoTaricFrExEditComponent } from './grupostaricfrex/grupotaricfrex-edit.component';
import { GrupoTaricFrExService } from './grupostaricfrex/grupotaricfrex.service';
import { GrupoEspecieFrExListComponent } from './gruposespeciesfrex/grupoespeciefrex-list.component';
import { GrupoEspecieFrExEditComponent } from './gruposespeciesfrex/grupoespeciefrex-edit.component';
import { GrupoEspecieFrExService } from './gruposespeciesfrex/grupoespeciefrex.service';
import { PaginatorModule } from 'primeng/paginator';
import { FrecuenciareducidaRoutingModule } from './frecuenciareducida-routing.module';

@NgModule({
    declarations: [
        PaisFrListComponent,
        PaisFrEditComponent,

        GrupoPaisFrListComponent,
        GrupoPaisFrEditComponent,

        GrupoTaricFrListComponent,
        GrupoTaricFrEditComponent,

        GrupoEspecieFrListComponent,
        GrupoEspecieFrEditComponent,

        GrupoTaricFrExListComponent,
        GrupoTaricFrExEditComponent,

        GrupoTaricFrSanidadExteriorListComponent,
        GrupoTaricFrSanidadExteriorEditComponent,

        GrupoEspecieFrExListComponent,
        GrupoEspecieFrExEditComponent,
    ],
    imports: [CoreModule, AppModuleGlobalShared, PaginatorModule, CommonModule, FormsModule, ReactiveFormsModule, FrecuenciareducidaRoutingModule],
    providers: [
        PaisFrService,
        GrupoPaisFrService,
        GrupoTaricFrService,
        GrupoTaricFrSanidadExteriorService,
        GrupoEspecieFrService,
        GrupoTaricFrExService,
        GrupoEspecieFrExService,
    ],
})
export class FrecuenciaReducidaModule {}
